export const request = async <T>(url: string, init?: RequestInit): Promise<T> => {
  let response: Response;
  try {
    response = await fetch(url, init);
  } catch {
    throw new Error('Could not reach the backend. Is it running? (yarn server)');
  }
  if (response.status === 204) {
    return undefined as T;
  }
  const isJson = response.headers.get('content-type')?.includes('application/json');
  const body = isJson ? await response.json().catch(() => null) : null;
  if (!response.ok) {
    throw new Error(body?.error ?? `Request failed with status ${response.status}`);
  }
  if (body === null) {
    // e.g. dev server answered with index.html because the /api proxy isn't active
    throw new Error('Backend returned an unexpected response. Restart "yarn start" so the /api proxy is active, and make sure "yarn server" is running.');
  }
  return body as T;
};

export const postJson = <T>(url: string, payload: unknown): Promise<T> =>
  request<T>(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
